import type { SupportedLanguage } from './index'

export const localizedRoutes = {
  home: {
    it: '',
    en: '',
  },
  about: {
    it: 'chi-siamo',
    en: 'about-us',
  },
  management: {
    it: 'gestione',
    en: 'management',
  },
  consulting: {
    it: 'consulenza',
    en: 'consulting',
  },
  training: {
    it: 'formazione',
    en: 'training',
  },
  careers: {
    it: 'lavora-con-noi',
    en: 'work-with-us',
  },
  locations: {
    it: 'dove-siamo',
    en: 'where-we-are',
  },
  contacts: {
    it: 'contatti',
    en: 'contacts',
  },
  legalNotes: {
    it: 'note-legali',
    en: 'legal-notes',
  },
  privacy: {
    it: 'privacy',
    en: 'privacy',
  },
  cookiePolicy: {
    it: 'cookie-policy',
    en: 'cookie-policy',
  },
} as const

export type RouteKey = keyof typeof localizedRoutes

/**
 * Get the localized path for a route
 */
export function getLocalizedPath(
  routeKey: RouteKey,
  lang: SupportedLanguage
): string {
  const path = localizedRoutes[routeKey][lang]
  return path ? `/${lang}/${path}` : `/${lang}`
}

/**
 * Find route key from a path segment
 */
export function findRouteKeyFromPath(
  pathSegment: string,
  lang: SupportedLanguage
): RouteKey | null {
  for (const [key, routes] of Object.entries(localizedRoutes)) {
    if (routes[lang] === pathSegment) {
      return key as RouteKey
    }
  }
  return null
}
